module.exports = __webpack_public_path__ + "static/img/jz_indicator.png";